<div #externalContentWrapper class = "externalContentWrapper" >
  <!--<h1>sdsdssdsdsdsd</h1>-->
  <!--<iframe #ecFrame id = "externalContentIframe" [srcdoc]="externalFeatureRequest$ | async"></iframe>-->
  <!--<div style="width: 300px; height: 800px; background-color: blueviolet;"></div>-->

  <!-- Maybe useful for later, but this is how we can assing the value from observable to template variable and reuse it later on -->
  <!--<ng-container *ngIf = "fff || (externalFeatureRequest$ | async) as respHTML; else loading">
  <div #externalContentContainer class = "externalContentContainer" innerHTML = "{{respHTML}}"></div>
</ng-container>
-->

<!--
externalContentWrapper -> is the flex container, has width of whole width screen and height of a bit less than height of screen
singleFlexItemWrapper -> Contains the externalContent and close button in a single flex-item. Has position: relative so that we can
easily place the close button in top-right corner with absolute positioning. (A child element with absolute positioning must have a parent
with position: relative, if the positioning is to be relative to that parent, If not then the absolute positioning would be relative to
some grandparent, the map in this case)
-->

<div class = "singleFlexItemWrapper" [@slideIn]="animationState">
  <button color="primary" class = "closeBtn closeButton" (click) = "closeView()">
    <mat-icon>close</mat-icon>
  </button>
  <!--<div #externalContentContainer class = "externalContentContainer" [innerHTML] = "externalFeatureRequest$ | async">-->
<!--</div>-->
<!--<iframe #externalContentContainer width="800" height="800" class = "externalContentContainer" [srcdoc] = "externalFeatureRequest$ | async"></iframe>-->
@if (externalFeatureRequest$ | async; as htmlContent) {
  <external-content-wrapper #externalContentContainer class = "externalContentContainer" [htmlContent]="htmlContent"></external-content-wrapper>
}
</div>
</div>
<!--
<ng-template #loading>
  <mat-spinner [diameter] = "40"></mat-spinner>
</ng-template>
-->
